import { songs } from "../constants";
import { daysSinceStart } from "./daysSinceStart";

const daysOf = (song: { days?: number }) => song.days ?? 1;
const totalDays = songs.reduce((total, song) => total + daysOf(song), 0);

// The songs list is the schedule: the first song plays on the start date and
// each song plays for its number of days before the next one.
const findInSchedule = (rightNowDate: Date) => {
  let day = daysSinceStart(rightNowDate) % totalDays;
  let index = 0;
  while (day >= daysOf(songs[index])) {
    day -= daysOf(songs[index]);
    index++;
  }
  return { index, daysLeft: daysOf(songs[index]) - day };
};

export const getTodaysSolution = (rightNowDate = new Date()) => {
  const { index } = findInSchedule(rightNowDate);
  console.log("index", index);
  let theSolution = songs[index];
  console.log("theSolution", theSolution);
  if (theSolution.artist === "Selena Gomez & The Scene") {
    // go back one song
    theSolution = songs[index - 1];
  }
  return theSolution;
};

// Days until a new song, counting today: 1 means it changes at midnight
export const daysUntilNextSong = (rightNowDate = new Date()) =>
  findInSchedule(rightNowDate).daysLeft;
